/* import __COLOCATED_TEMPLATE__ from './stripe-cc-modal.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { closeModal } from "sh-www/utils/modal-controls";

class StripeCreditCardModalComponent extends Component {
  tagName = '';

  @service('commands/company-commands')
  companyCommandService;

  @service('error-tracker')
  errorTracker;

  @service
  stripe;

  @service
  session;

  get canAddCreditCard() {
    return this.session.currentUser.canViewReports;
  }

  @task
  *handleSubmit(cardElement) {
    const { onSuccess } = this.model;
    const { currentUser } = this.session;
    const { company } = currentUser;

    try {
      const token = yield this.stripe.createToken(cardElement);
      const card = yield this.companyCommandService.addNewCardForCompany(company, token.id);
      yield this.companyCommandService.makeCardDefault(card);
      yield this.session.loadCurrentUser();
    } catch (e) {
      this.errorTracker.error(e, this, `error adding credit card to company [${company.id}] with user [${currentUser.id}]`);
      throw e;
    }

    closeModal(this);
    onSuccess?.();
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  handleCancel() {
    const { seller, application } = this.model;

    closeModal(this);
    this.companyCommandService.ccCaptureDeclined(seller, application);
  }
}

export default StripeCreditCardModalComponent;
